"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FulfillmentRequestStatus = void 0;
// Note: FulfillmentRequest entity current has 20-character limit.
//   If adding a new status with greater length, adjust entity to accommodate.
var FulfillmentRequestStatus;
(function (FulfillmentRequestStatus) {
    FulfillmentRequestStatus["PENDING"] = "PENDING";
    FulfillmentRequestStatus["CANCELLED"] = "CANCELLED";
    FulfillmentRequestStatus["COMPLETED"] = "COMPLETED";
})(FulfillmentRequestStatus = exports.FulfillmentRequestStatus || (exports.FulfillmentRequestStatus = {}));
//# sourceMappingURL=FulfillmentRequestStatus.js.map